<template>
    <div class="modal">
        <div class="modal-content">
            <!-- <div class="close_box">
                <img src="../assets/images/common/close.png" class="close">
            </div> -->
            <slot />
        </div>
    </div>
</template>
<script>
export default {
    props: {
    },
    data() {
        return {
            visible: false,
        };
    },
    watch: {
    },
    methods: {
        showModal() {
            this.visible = true;
        },
    },
};

</script>
<style scoped lang="less">
@import "../assets/css/variables.less";

.modal {
    display: block;
    position: fixed;
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}


.modal-content {
    box-sizing: border-box;
    position: relative;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 90%;
    background-color: @third-color;
    // height: 10rem;
    top: 20%;
    padding-top: 5px;
    border-radius: .3rem;
    max-width: 375px;
}

.modal-content .title {
    color: @textcolor1;
    font-size: .55rem;
    text-align: center;
    margin-bottom: .3rem;
    margin-top: .3rem;
}

/deep/.modal-content p img {
    width: 100%;
}

// .close {
//     position: absolute;
//     right: 10px;
//     top: 10px;
//     color: #aaa;
//     font-size: 28px;
//     font-weight: bold;
//     cursor: pointer;
// }
.close_box {
    position: absolute;
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%);

    .close {
        width: 20px;
        height: 20px;
        display: block;
    }
}
</style>